// extracted by extract-css-chunks-webpack-plugin
module.exports = {"supported-label":"card-payment-method__supported-label___2toHG","supportedLabel":"card-payment-method__supported-label___2toHG","col-zipcode":"card-payment-method__col-zipcode___3Lgel","colZipcode":"card-payment-method__col-zipcode___3Lgel"};
    if(module.hot) {
      // 1631577380065
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  